import moment from "moment";

export class Period {
  min: string;
  max: string;

  constructor(min: string, max: string) {
    this.min = min;
    this.max = max;
  }
}

export class DateFormat {

  /* Return date on v-date-picker format with
   *  - null if parameter is null (ex : non constraint)
   *  - today if parameter is '' (ex : default not set)
   *  - parameter else
   */


  public static toEdit (date: string | null): string {
    if (!date) {
      return '';
    } else {
      // Date comming from picker
      const mp = date.toString().match('([0-9]{4})-([0-9]{2})-([0-9]{2})');
      if (mp) {
        return mp[3] + '/' + mp[2] + '/' + mp[1];
      } else {
        // date coming from store (GMT fromat)
        const me = date.toString().match('([0-9]{2})/([0-9]{2})/([0-9]{4})');
        if (me) {
          return me[1] + '/' + me[2] + '/' + me[3];
        } else {
          return '';
        }
      }
    }
  }

  public static toPicker (date: string | null | Date): string {
    if (date instanceof Date) {
      date = date.toString();
    }
    if (!date) {
      return '';
    } else {
      // date coming from store (GMT fromat)
      const me = date.toString().match('([0-9]{2})/([0-9]{2})/([0-9]{4})');
      if (me) {
        return me[3] + '-' + me[2] + '-' + me[1];
      } else {
        // Date comming from picker
        const mp = date.toString().match('([0-9]{4})-([0-9]{2})-([0-9]{2})');
        if (mp) {
          return mp[1] + '-' + mp[2] + '-' + mp[3];
        } else {
          return '';
        }
      }
    }
  }
  public static toIso (date: string): string {
    return new Date(DateFormat.toPicker(date)).toISOString();
  }

  public static toFileName (value: string): string {
    const date = new Date(value);
    const year = date.getFullYear().toString().slice(-2); // Récupère les 2 derniers chiffres de l'année
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}${month}${day}`;  }

  public static toFullTimestamp(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');

    return `${year}${month}${day} ${hh}${mm}${ss}`;
  }


  public static addTimes (startTime: string, endTime: string) {
    const times = [0, 0, 0]
    const max = times.length

    const a: number[] = [];
    const b: number[] = [];

    const start = (startTime || '').split(':');
    const end = (endTime || '').split(':')

    for (let i = 0; i < max; i++) {
      a[i] = isNaN(parseInt(start[i])) ? 0 : parseInt(start[i])
      b[i] = isNaN(parseInt(end[i])) ? 0 : parseInt(end[i])
    }

    for (let i = 0; i < max; i++) {
      times[i] = a[i] + b[i]
    }

    let hours = times[0]
    let minutes = times[1]

    if (minutes >= 60) {
      const h = (minutes / 60) << 0
      hours += h
      minutes -= 60 * h
    }

    if (hours + minutes == 0) {
      return '';
    }

    return hours + ':' + ('0' + minutes).slice(-2)
  }

  public static calculateRate (rate: number, time: string): number {
    const heuresMinutes = DateFormat.getHeures(time);
    if (heuresMinutes) {
      return heuresMinutes * rate;
    } else {
      return 0;
    }
  }

  public static toNumber (value: string): number {
    const formattedDate = DateFormat.toPicker(value);
    if (formattedDate != '') {
      return parseInt(formattedDate.replace('-', ''));
    }

    return -1;
  }

  public static getHeures (value: string): number {
    let res = 0;
    const formatedValue = DateFormat.getHeuresMinutes(value);
    const hoursMinutes = formatedValue.split(':');
    if (hoursMinutes.length == 2) {
      const hours = hoursMinutes[0];
      const minutes = hoursMinutes[1];
      if (hours.length == 2 && minutes.length == 2) {
        res = parseFloat(hours) + parseFloat(minutes) / 60.0;
      }
    }
    return res;

  }
  public static getHeuresMinutes (value: string): string {
    let res = '';
    let hours = 0;
    let minutes = 0;
    if (value.includes(':')) {
      hours = parseInt(value.split(':')[0]);
      if (!hours) hours = 0;
      minutes = parseInt(value.split(':')[1]);
      if (!minutes) minutes = 0;
    } else {
      if (value.length == 4) {
        hours = parseInt(value.substring(0, 2));
        minutes = parseInt(value.substring(2, 4));
      } else if (value.length == 3) {
        const h = parseInt(value.substring(0, 2));
        if (h > 24) {
          hours = parseInt(value.substring(0, 1));
          minutes = parseInt(value.substring(1, 3));
        } else {
          hours = parseInt(value.substring(0, 2));
          minutes = parseInt(value.substring(2, 3));
        }
      } else if (value.length == 2) {
        const h = parseInt(value.substring(0, 2));
        if (h > 24) {
          hours = parseInt(value.substring(0, 1));
          minutes = parseInt(value.substring(1, 2));
        } else {
          hours = parseInt(value.substring(0, 2));
        }
      } else {
        hours = parseInt(value);
      }
    }
    if (hours > 23) { hours = 23; minutes = 59 }
    if (minutes > 59) minutes = 59;
    res = (hours > 9 ? '' : '0') + hours.toString() + ':' + (minutes > 9 ? '' : '0') + minutes.toString()
    return res;
  }

  public static getQuantityHeuresMinutes (decimalValue: number): string {
    let res = '';
    const hours = Math.trunc(decimalValue);
    const minutes = Math.trunc((decimalValue - hours) * 60.0 + 0.99);
    if (hours || minutes) {
      res = hours.toString() + 'h' + (minutes > 9 ? '' : '0') + minutes.toString()
    }
    return res;
  }

  public static heuresMinutes (value: string): string {
    const hm = value.split(':');
    const hours = hm.length > 0 && hm[0] != '' ? Math.min(parseInt(hm[0]), 23) : 0;
    const minutes = hm.length > 1 && hm[1] != '' ? Math.min(parseInt(hm[1]), 59) : 0;
    return (hours > 9 ? '' : '0') + hours.toString() + ':' + (minutes > 9 ? '' : '0') + minutes.toString()
  }

  public static getDateLabel (value: Date | null): string {
    let label = '';
    if (value != null) {
      label = DateFormat.toEdit(value.toString());
    }
    return label;
  }

  public static getMensuelLabel (value: Date | null): string {
    let label = '';
    if (value != null) {
      const date = new Date(value)
      label = DateFormat.getMonth(date) + ' ' + date.getFullYear().toString();
    }
    return label;
  }

  public static getTrimestrielLabel (value: Date | null): string {
    let label = '';
    if (value != null) {
      const date = new Date(value)
      label = DateFormat.getTrimestre(date) + ' ' + date.getFullYear().toString();
    }
    return label;
  }
  public static getAnnuelLabel (value: Date | null): string {
    let label = '';
    if (value != null) {
      const date = new Date(value)
      label = 'Année ' + date.getFullYear().toString();
    }
    return label;
  }

  public static getDebutFinLabel (debut: Date, fin: Date | null): string {
    let label = '';
    if (fin == null || fin == undefined) {
      const date = new Date(debut)
      label = date.getFullYear().toString();
    } else {
      const dateDebut = new Date(debut)
      const dateFin = new Date(fin)
      if (dateDebut.getFullYear() == dateFin.getFullYear() &&
        dateDebut.getMonth() == dateFin.getMonth() &&
        dateDebut.getDate() == dateFin.getDate()) {
        label = 'Le ' + DateFormat.getDateLabel(dateDebut);
      } else {
        label = 'Du ' + DateFormat.getDateLabel(dateDebut) + ' au ' + DateFormat.getDateLabel(dateFin);
      }
    }
    return label;
  }

  public static listMonths = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  private static getMonth (value: Date): string {
    return DateFormat.listMonths[value.getMonth()];
  }

  public static listTrimestre = ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'];
  private static getTrimestre (value: Date): string {
    return DateFormat.listTrimestre[value.getMonth() / 3];
  }
}

export function getDayDiff (startDate: Date | null, endDate: Date | null, defaut: number): number {
  let res = defaut;
  if (startDate != null && endDate != null) {
    const msInDay = 24 * 60 * 60 * 1000;
    res = Math.round((Number(new Date(endDate)) - Number(new Date(startDate))) / msInDay);
  }
  return res;
}

export function getDateProgress (startDate: Date | null, endDate: Date | null): number {
  let res = 0;
  if (startDate != null && endDate != null) {
    if (new Date(startDate) < new Date()) {
      if (new Date(endDate) < new Date()) {
        res = 100;
      } else {
        const msInDay = 24 * 60 * 60 * 1000;
        res = Math.round((Number(new Date(endDate)) - Number(new Date(startDate))) / msInDay);
      }
    }
  }
  return res;
}

export function isValidDate (dateString: string): boolean {
  const dateFormats = ['YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ'];
  return moment(dateString, dateFormats, true).isValid();
}